import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Paperclip({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg width={'22px'} height={'23px'} viewBox={'0 0 22 23'}>
        <g
          stroke={'none'}
          strokeWidth={'1'}
          className={'icon__fill'}
          fillRule={'evenodd'}
        >
          <g transform={'translate(-1.000000, 0.000000)'} fillRule={'nonzero'}>
            <path
              d={
                'M20.7328932,10.3428932 C21.1234175,9.95236893 21.7565825,9.95236893 22.1471068,10.3428932 C22.5376311,10.7334175 22.5376311,11.3665825 22.1471068,11.7571068 L12.9571068,20.9471068 C10.2221337,23.6820798 5.78786627,23.6820798 3.05289322,20.9471068 C0.317920164,18.2121337 0.317920164,13.7778663 3.05289322,11.0428932 L12.2428932,1.85289321 C14.1963834,-0.100596876 17.3636166,-0.100596852 19.3171067,1.85289326 C21.2705969,3.80638337 21.2705969,6.97361663 19.3167222,8.92749118 L10.1171068,18.1171068 C8.94509957,19.289114 7.04490043,19.289114 5.87289322,18.1171068 C4.70088601,16.9450996 4.70088601,15.0449004 5.87331002,13.8724767 L14.36331,5.39247666 C14.7540644,5.00218256 15.3872292,5.00255567 15.7775233,5.39331002 C16.1678174,5.78406437 16.1674443,6.41722924 15.77669,6.80752334 L7.28710678,15.2871068 C6.89614815,15.6780654 6.89614815,16.3119346 7.28710678,16.7028932 C7.67806541,17.0938518 8.31193459,17.0938518 8.70327783,16.7025088 L17.9028932,7.51289323 C19.0753347,6.34045167 19.0753347,4.43954836 17.9028932,3.26710682 C16.7304516,2.09466529 14.8295483,2.09466527 13.6571068,3.26710678 L4.46710678,12.4571068 C2.51318231,14.4110313 2.51318231,17.5789687 4.46710678,19.5328932 C6.42103125,21.4868177 9.58896875,21.4868177 11.5428932,19.5328932 L20.7328932,10.3428932 Z'
              }
            ></path>
          </g>
        </g>
      </svg>
    </div>
  )
}

Paperclip.propTypes = {
  className: PropTypes.string,
}
